import cloneDeep from 'lodash-es/cloneDeep';
import * as moment from 'moment';
import buildQuery from 'odata-query';

export interface ODataFilterProperty
    extends Record<string, ODataFilterValue | ODataFilterProperty | string | number | Date | null> { }

export interface ODataComparisonProperty {
    or?: Array<ODataFilterProperty | ODataComparisonProperty | string>;
    and?: Array<ODataFilterProperty | ODataComparisonProperty | string>;
}

export interface ODataQueryOptions {
    select?: string[];
    filter?: string | ODataFilterProperty | ODataComparisonProperty;
    search?: string;
    groupBy?: {
        properties: string[],
    };
    orderBy?: string[];
    top?: number;
    skip?: number;
    expand?: string[] | ODataExpandValue;
}

interface ODataFilterValue {
    eq?: number | string | boolean | null;
    ne?: number | string | boolean | null;
    gt?: number | string;
    ge?: number | string;
    lt?: number | string;
    le?: number | string;
    startswith?: string;
    endswith?: string;
    contains?: string;
    any?: string | number | boolean;
    all?: string | number | boolean;
}

interface ODataExpandValue {
    [key: string]: ODataQueryOptions;
}

// double-encode the payload to be compatible with Orchestrator backend ;(
export const buildODataQuery = (queryOptions: ODataQueryOptions) => {
    const payload = cloneDeep(queryOptions);
    payload.filter = encodeLeafs(payload.filter);
    if (payload.search != null) {
        payload.search = standardEncoding(payload.search);
    }
    return buildQuery(payload);
};

export default buildODataQuery;

function standardEncoding(v: string): string {
    return encodeURIComponent(v)
        .replace(/%40/gi, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/gi, '$')
        .replace(/%2C/gi, ',')
        .replace(/%3B/gi, ';')
        .replace(/%3F/gi, '?')
        .replace(/%2F/gi, '/');
}

function encodeLeafs(filterOptions?: string | ODataFilterProperty | ODataComparisonProperty): any {
    if (
        filterOptions == null ||
        moment.isDate(filterOptions) ||
        typeof filterOptions === 'boolean'
    ) {
        return filterOptions;
    }

    if (typeof filterOptions === 'number') {
        return filterOptions;
    }

    if (typeof filterOptions === 'string') {
        return standardEncoding(filterOptions);
    }

    if (Array.isArray(filterOptions)) {
        return filterOptions.map(v => encodeLeafs(v));
    }

    const keys = Object.keys(filterOptions);
    const options: Record<string, any> = {};
    keys.forEach(key =>
        options[key] = encodeLeafs((filterOptions as Record<string, any>)[key]),
    );
    return options;
}
